<template>
  <div
    class="relative flex items-center justify-center w-full overflow-hidden sm:object-scale-down sm:object-center aspect-video sm:rounded-lg bg-slate-100 dark:bg-zinc-800"
  >
    <div class="flex flex-col gap-3 sm:gap-6 scale-to-aspect-ratio">
      <div class="relative w-20 mx-auto sm:w-40">
        <ImageSvg name="general.customFile" />
        <span
          class="absolute inline-block px-4 py-1 text-2xl font-bold text-white uppercase rounded-full sm:text-5xl -right-4 sm:-right-8 top-8 sm:top-14 bg-slate-600"
        >
          {{ store.fileExt }}
        </span>
      </div>
      <div>
        <a
          :href="store.downloadLink"
          data-testid="viewer-content-unsupported-download"
          class="flex justify-center items-center gap-2 px-2 sm:px-4 py-0.5 text-xs sm:text-sm font-bold leading-4 text-black dark:text-zinc-200 border border-black dark:border-zinc-200 h-9 rounded-10 bg-transparent hover:bg-slate-200 dark:hover:bg-zinc-700 active:bg-black active:text-white focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none"
        >
          <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21 14C20.7348 14 20.4804 14.1054 20.2929 14.2929C20.1054 14.4804 20 14.7348 20 15V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V15C4 14.7348 3.89464 14.4804 3.70711 14.2929C3.51957 14.1054 3.26522 14 3 14C2.73478 14 2.48043 14.1054 2.29289 14.2929C2.10536 14.4804 2 14.7348 2 15V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V15C22 14.7348 21.8946 14.4804 21.7071 14.2929C21.5196 14.1054 21.2652 14 21 14ZM11.29 15.71C11.3851 15.801 11.4972 15.8724 11.62 15.92C11.7397 15.9729 11.8691 16.0002 12 16.0002C12.1309 16.0002 12.2603 15.9729 12.38 15.92C12.5028 15.8724 12.6149 15.801 12.71 15.71L16.71 11.71C16.8983 11.5217 17.0041 11.2663 17.0041 11C17.0041 10.7337 16.8983 10.4783 16.71 10.29C16.5217 10.1017 16.2663 9.99591 16 9.99591C15.7337 9.99591 15.4783 10.1017 15.29 10.29L13 12.59V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V12.59L8.71 10.29C8.61676 10.1968 8.50607 10.1228 8.38425 10.0723C8.26243 10.0219 8.13186 9.99591 8 9.99591C7.86814 9.99591 7.73757 10.0219 7.61575 10.0723C7.49393 10.1228 7.38324 10.1968 7.29 10.29C7.19676 10.3832 7.1228 10.4939 7.07234 10.6158C7.02188 10.7376 6.99591 10.8681 6.99591 11C6.99591 11.1319 7.02188 11.2624 7.07234 11.3842C7.1228 11.5061 7.19676 11.6168 7.29 11.71L11.29 15.71Z"
              class="fill-current"
            />
          </svg>
          <span class="whitespace-nowrap">Download</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ImageSvg } from '@/storybook';
import { useViewerItemStore } from './../../store/useViewerItemStore';

defineProps<{
  src: string;
}>();

const store = useViewerItemStore();
</script>
